"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = stats;
function stats() {
  var _this = this;

  return {
    total: function total() {
      var url = "/stats/total";

      return _this.request({
        url: url,
        method: "GET"
      });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/unsplash-js/lib/methods/stats.js
// module id = 2472
// module chunks = 0